import React, { useState } from 'react';
import Header from './Header';

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('form');
  const [formName, setFormName] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [fields, setFields] = useState([]);
  const [showFieldForm, setShowFieldForm] = useState(false);
  const [editingField, setEditingField] = useState(null);
  
  // Field form states
  const [fieldName, setFieldName] = useState('');
  const [fieldType, setFieldType] = useState('Text Input');
  const [validation, setValidation] = useState('');
  const [hasValidation, setHasValidation] = useState(false);

  const fieldTypes = [
    'Text Input',
    'Radio Button',
    'Dropdown List',
    'File',
    'Textarea (Paragraph)',
    'Checkbox'
  ];

  const validationTypes = [
    'Number',
    'Character',
    'Alphanumeric',
    'Email',
    'File size/type'
  ];

  const handleAddField = () => {
    if (fieldName && fieldType) {
      const newField = {
        id: Date.now(),
        name: fieldName,
        fieldType,
        validation: hasValidation ? validation : 'None',
        hasValidation
      };
      
      if (editingField) {
        setFields(fields.map(f => f.id === editingField.id ? { ...newField, id: editingField.id } : f));
      } else {
        setFields([...fields, newField]);
      }
      
      handleCancelEdit();
    }
  };

  const handleEditField = (field) => {
    setEditingField(field);
    setFieldName(field.name);
    setFieldType(field.fieldType);
    setValidation(field.validation === 'None' ? '' : field.validation);
    setHasValidation(field.hasValidation);
    setShowFieldForm(true);
  };

  const handleCancelEdit = () => {
    setFieldName('');
    setFieldType('Text Input');
    setValidation('');
    setHasValidation(false);
    setShowFieldForm(false);
    setEditingField(null);
  };

  const handleDeleteField = (id) => {
    setFields(fields.filter(f => f.id !== id));
  };

  const handleSave = () => {
    const existingForms = JSON.parse(localStorage.getItem('forms') || '[]');
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    const newForm = {
      id: Date.now(),
      name: formName,
      department: departmentName,
      fields: fields,
      createdBy: currentUser.name,
      createdAt: new Date().toISOString()
    };
    
    existingForms.push(newForm);
    localStorage.setItem('forms', JSON.stringify(existingForms));
    
    alert('Form saved successfully!');
    
    setFormName('');
    setDepartmentName('');
    setFields([]);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      
      <Header />

      <div className="p-6">
        
        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex gap-4 border-b">
            <button
              onClick={() => setActiveTab('form')}
              className={`pb-3 px-4 font-medium transition ${
                activeTab === 'form' 
                  ? 'border-b-2 border-blue-600 text-blue-600' 
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              Form Name
            </button>
            <button
              onClick={() => setActiveTab('department')}
              className={`pb-3 px-4 font-medium transition ${
                activeTab === 'department' 
                  ? 'border-b-2 border-blue-600 text-blue-600' 
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              Department Name
            </button>
          </div>

          <div className="mt-6">
            {activeTab === 'form' ? (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Form Name</label>
                <input
                  type="text"
                  value={formName}
                  onChange={(e) => setFormName(e.target.value)}
                  placeholder="Enter form name"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                />
              </div>
            ) : (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Department Name</label>
                <select
                  value={departmentName}
                  onChange={(e) => setDepartmentName(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                >
                  <option value="">Select Department</option>
                  <option value="Department A">Department A</option>
                  <option value="Department B">Department B</option>
                  <option value="Department C">Department C</option>
                </select>
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6">
          
          {/* Left Side - Fields List */}
          <div className="bg-white rounded-lg shadow-sm p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-semibold text-gray-800">Form Fields</h2>
              <button
                onClick={() => setShowFieldForm(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
              >
                + Add Field
              </button>
            </div>

            {fields.length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                No fields added yet
              </div>
            ) : (
              <div className="space-y-3">
                {fields.map((field) => (
                  <div 
                    key={field.id}
                    className="flex items-center justify-between p-4 border border-gray-200 rounded-md hover:border-gray-300 transition"
                  >
                    <div>
                      <p className="font-medium text-gray-800">{field.name}</p>
                      <p className="text-sm text-gray-600">{field.fieldType}</p>
                      {field.hasValidation && (
                        <p className="text-xs text-blue-600 mt-1">Validation: {field.validation}</p>
                      )}
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEditField(field)}
                        className="px-3 py-1 text-blue-600 hover:bg-blue-50 rounded transition"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteField(field.id)}
                        className="px-3 py-1 text-red-600 hover:bg-red-50 rounded transition"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {fields.length > 0 && (
              <button
                onClick={handleSave}
                disabled={!formName || !departmentName}
                className="w-full mt-6 px-4 py-3 bg-green-600 text-white rounded-md font-medium hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition"
              >
                Save Form
              </button>
            )}
          </div>

          {/* Right Side - Field Form */}
          <div className="bg-white rounded-lg shadow-sm p-6">
            {!showFieldForm ? (
              <div className="flex items-center justify-center h-full text-gray-500">
                Click "Add Field" to create a new field
              </div>
            ) : (
              <div>
                <h2 className="text-lg font-semibold text-gray-800 mb-6">
                  {editingField ? 'Edit Field' : 'Add New Field'}
                </h2>

                <div className="space-y-4">
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Field Name</label>
                    <input
                      type="text"
                      value={fieldName}
                      onChange={(e) => setFieldName(e.target.value)}
                      placeholder="e.g. Name, Age, City"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Field Type</label>
                    <select
                      value={fieldType}
                      onChange={(e) => setFieldType(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                    >
                      {fieldTypes.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={hasValidation}
                        onChange={(e) => setHasValidation(e.target.checked)}
                        className="w-4 h-4"
                      />
                      <span className="text-sm font-medium text-gray-700">Add Validation</span>
                    </label>
                  </div>

                  {hasValidation && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Validation Type</label>
                      <select
                        value={validation}
                        onChange={(e) => setValidation(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                      >
                        <option value="">Select validation</option>
                        {validationTypes.map(type => (
                          <option key={type} value={type}>{type}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="flex gap-3 pt-4">
                    <button
                      onClick={handleCancelEdit}
                      className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleAddField}
                      disabled={!fieldName}
                      className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition"
                    >
                      {editingField ? 'Update' : 'Add'}
                    </button>
                  </div>

                </div>
              </div>
            )}
          </div>

        </div>

      </div>

    </div>
  );
}

export default AdminDashboard;